export default "__VITE_ASSET__db915e0b__"